<template>
    <div class="dashboard-employee-card-background">
        <b-button class="dashboard-employee-card-button-style" v-b-toggle.accordion-open-action-documents>
            <div class="float-right">
                <span class="mr-2 badge badge-secondary">{{ openActionDocumentsCount }}</span>
                <span class="mr-2 badge badge-danger">{{ openActionDocumentsLateCount }}</span>
                <i v-if="this.open" class="fa fa-chevron-right" aria-hidden="true"></i>
                <i v-else class="fa fa-chevron-down" aria-hidden="true"></i>
            </div>
            {{ uLang('app.open_action_documents') }}
        </b-button>

        <b-collapse class="dashboard-employee-card-collapse" id="accordion-open-action-documents">
            <rea-loader :loading="loading"></rea-loader>

            <div class="d-flex align-items-center mt-3" v-if="hasOpenActionDocuments">
                <span class="mr-2">{{ uLang('app.rows_per_page_text') }}:</span>
                <select class="rowsPerPageClass" v-model.number="tablePageSize">
                    <option :value="15">15</option>
                    <option :value="30">30</option>
                    <option :value="45">45</option>
                    <option :value="60">60</option>
                    <option :value="90">90</option>
                </select>
            </div>

            <table class="action-documents-table table mt-2">
                <tr v-if="!hasOpenActionDocuments">
                    <td colspan="4">{{ uLang('app.empty_table') }}</td>
                </tr>
                <tr class="table-heading" v-else>
                    <th class="override-th-min-width"></th>
                    <th class="w10">{{ uLang('app.candidate') }}</th>
                    <th class="w30">{{ uLang('app.trajectory') }}</th>
                    <th class="w10">{{ uLang('app.trajectory_manager_literal') }}</th>
                    <th class="w10">{{ uLang('app.rapport') }}</th>
                    <th class="icon-sort-header" @click="sortTable('submitted_at')">
                        <span class="header-content">
                            {{ uLang('app.submitted_at') }}
                            <span class="icon-sort" :class="{
                                '-ascending': sortColumn === 'submitted_at' && sortOrder === 'asc',
                                '-descending': sortColumn === 'submitted_at' && sortOrder === 'desc'
                            }">
                            </span>
                        </span>
                    </th>
                    <th class="w10">{{ uLang('app.followup_action_by') }}</th>
                    
                    <th class="icon-sort-header" @click="sortTable('action_progress.due_date')">
                        <span class="header-content">
                            {{ uLang('app.deadline') }}
                            <span class="icon-sort" :class="{
                                '-ascending': sortColumn === 'action_progress.due_date' && sortOrder === 'asc',
                                '-descending': sortColumn === 'action_progress.due_date' && sortOrder === 'desc'
                            }">
                            </span>
                        </span>
                    </th>
                </tr>

                <!-- Filters -->
                <tr v-if="hasOpenActionDocuments">
                    <td colspan="2"></td>
                    <td>
                        <input
                            type="text"
                            class="form-control"
                            :placeholder="uLang('app.search_by_trajectory')"
                            v-model="filters.trajectory"
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            class="form-control"
                            :placeholder="uLang('app.search_by_trajectory_manager')"
                            v-model="filters.trajectory_manager"
                        />
                    </td>
                    <td>
                        <input
                            type="text"
                            class="form-control"
                            :placeholder="uLang('app.search_by_report')"
                            v-model="filters.report"
                        />
                    </td>
                    <td colspan=""></td>
                    <td>
                        <filter-toggle-button v-model="inspectorOnly">
                            {{ uLang('app.trajectory_administrator') }}
                        </filter-toggle-button>
                    </td>
                    <!-- <td>
                        <div class="input-group">
                            <input
                                type="text"
                                class="form-control inline-input"
                                :placeholder="moment().format('DD-MM-YYYY')"
                                v-model="filters.deadline"
                                style="width: 8em"
                            />
                        </div>
                    </td> -->
                </tr>

                <!-- Rows -->
                <tr v-for="openActionDocument in pagedDocuments"
                    v-if="openActionDocument.action_progress">
                    <td>
                        <i class="ti-email pointer"
                        @click.prevent="sendLogToRelation(openActionDocument.action_progress.milestone_progress.trajectory_enrolment.relation)"
                        ></i>
                    </td>
                    <td>
                        <name-telephone-field
                            :relation="openActionDocument.action_progress.milestone_progress.trajectory_enrolment.relation"/>
                    </td>
                    <td>
                        <router-link
                            :to="trajectoryLink(openActionDocument)"
                            v-text="openActionDocument.action_progress.milestone_progress.trajectory_enrolment.trajectory.name"
                            target="_blank"
                        />
                    </td>
                    <td>
                        <name-telephone-field
                            :relation="openActionDocument.action_progress.milestone_progress.trajectory_enrolment.trajectory_manager"
                        />
                    </td>

                    <td>
                        <router-link
                            :to="actionDocumentLink(openActionDocument)"
                            v-text="openActionDocument.action_progress.action.name"
                            target="_blank"
                        />
                    </td>
                    <td>
                        <span v-for="check in openActionDocument.checks"
                            v-if="!check.agreed && check.checker"
                            :key="check.id">
                            {{ check.created_at | date }}
                        </span>
                    </td>
                    <td>
                        <!-- If there's a checker coupled and he hasn't agreed, show a link (to the candidate) -->
                        <router-link
                            target="_blank"
                            class="checker"
                            v-for="check in openActionDocument.checks"
                            v-if="!check.agreed && check.checker"
                            :key="check.id"
                            :to="{
                                name: 'admin.relations.view',
                                params: {
                                    'id': check.checker.id,
                                }
                            }">
                            {{ check.checker.full_name }} 
                            <!-- ({{ lang('app.submitted_at') }}: {{ check.created_at | date }}) -->
                        </router-link>
                        <!-- If there isn't a checker, it means the backoffice/trajectory inspector (-->
                        <span v-else-if="!check.agreed && check.type === 'trajectory_inspector'"
                            v-text="uLang('app.trajectory_administrator')"/>
                    </td>
                    <td>{{ openActionDocument.action_progress.due_date | date }}</td>
                    
                </tr>
            </table>

            <div class="VuePagination" v-if="hasOpenActionDocuments && filteredOpenActionDocuments.length > 0">
                <ul class="pagination VuePagination__pagination" v-show="totalPages > 1">
                    <li class="VuePagination__pagination-item page-item VuePagination__pagination-item-prev-chunk"
                        :class="{ disabled: currentChunk <= 1 }">
                        <a class="page-link" href="javascript:void(0);" @click="goPrevChunk">&lt;&lt;</a>
                    </li>
                    <li class="VuePagination__pagination-item page-item VuePagination__pagination-item-prev-page"
                        :class="{ disabled: tablePage === 0 }">
                        <a class="page-link" href="javascript:void(0);" @click="tablePage--">&lt;</a>
                    </li>
                    <li v-for="p in chunkPageNumbers" :key="p"
                        class="VuePagination__pagination-item page-item"
                        :class="{ active: tablePage === p - 1 }">
                        <a class="page-link" role="button" @click="tablePage = p - 1">{{ p }}</a>
                    </li>
                    <li class="VuePagination__pagination-item page-item VuePagination__pagination-item-next-page"
                        :class="{ disabled: tablePage >= totalPages - 1 }">
                        <a class="page-link" href="javascript:void(0);" @click="tablePage++">&gt;</a>
                    </li>
                    <li class="VuePagination__pagination-item page-item VuePagination__pagination-item-next-chunk"
                        :class="{ disabled: currentChunk >= totalChunks }">
                        <a class="page-link" href="javascript:void(0);" @click="goNextChunk">&gt;&gt;</a>
                    </li>
                </ul>
                <p class="VuePagination__count">{{ paginationCount }}</p>
            </div>

        </b-collapse>

        <b-modal
            class="log-modal-lg"
            :close-on-esc="false"
            :close-on-backdrop="false"
            :hideFooter="true"
            :title="uLang('app.add_type', { type: uLang('app.log') })"
            :key="log_form_key"
            ref="relationLogsModal"
            size="lg"
            v-if="($can('create-intern-logs')
                    || $can('update-intern-logs')
                    || $can('create-report-logs')
                    || $can('update-report-logs')
                    || $can('create-candidate-logs')
                    || $can('update-candidate-logs'))
            && relation_id !== null"
        >
            <log-form
                @logCreated="handleLogCreated"
                @categoryChanged="handleCategoryChanged"
                entityType="relations"
                :entityId="relation_id"
                :overrideEndpoint="logsFormApiUrl"
            />
        </b-modal>
    </div>
</template>
<script>
import {LogForm} from '~/components/forms'
import {ReaLoader} from '~/components/helpers'
import MultiSelect from 'vue-multiselect'
import NameTelephoneField from "../../../elements/name-telephone-field";
import FilterToggleButton from "../../../elements/filter-toggle-button";
import {debounce} from "lodash";
import moment from "moment";
import {DashboardFilter} from "~/mixins";

export default {
    name: 'OpenActionDocuments',

    components: {
        NameTelephoneField,
        ReaLoader, MultiSelect, LogForm,
        FilterToggleButton,
    },

    mixins: [
        DashboardFilter,
    ],

    data() {
        return {
            filteredOpenActionDocuments: [],
            openActionDocuments: [],
            loading: true,
            open: false,
            openActionDocumentsCount: 0,
            openActionDocumentsLateCount: 0,

            sortColumn: '',
            sortOrder: 'asc',

            inspectorOnly: false,

            tablePage: 0,
            tablePageSize: 15,
        }
    },

    async created() {
        this.$root.$on('collapse::toggle', async (target, show) => {
            if (target == 'accordion-open-action-documents') {
                this.open = !this.open;
            }
        });
        this.$root.$on('collapse::toggle::state', async (target, show) => {
            if (target == 'accordion-open-action-documents') {
                if (show == true && this.loading == true) {
                    const { data } = await window.axios.get(route("dashboard.open-action-documents"));
                    this.openActionDocuments = data.trajectory_inspector.open_action_documents;
                    this.loading = false;
                }
            }
        });

        const { data } = await window.axios.get(route("dashboard.open-action-documents.count"));
        this.openActionDocumentsCount = data.open_action_documents_count.count;
        this.openActionDocumentsLateCount = data.open_action_documents_count.due_count;
    },

    watch: {
        openActionDocuments() {
            this.applyAllFilters();
        },
        // ID-364: All filter watchers call applyAllFilters() which always starts from the full
        // source data — fixes filter stacking bug and ensures search covers all records.
        'filters.trajectory':         debounce(function () { this.applyAllFilters(); }, 500),
        'filters.trajectory_manager': debounce(function () { this.applyAllFilters(); }, 500),
        'filters.report':             debounce(function () { this.applyAllFilters(); }, 500),
        inspectorOnly() {
            this.applyAllFilters();
        },
        tablePageSize() {
            this.tablePage = 0;
        },

        sortColumn() {
            this.sortData();
        },
        sortOrder() {
            this.sortData();
        },
    },

    computed: {
        hasOpenActionDocuments() {
            return !_.isEmpty(this.openActionDocuments)
        },
        pagedDocuments() {
            const start = this.tablePage * this.tablePageSize;
            return this.filteredOpenActionDocuments.slice(start, start + this.tablePageSize);
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.filteredOpenActionDocuments.length / this.tablePageSize));
        },
        paginationStart() {
            return this.filteredOpenActionDocuments.length === 0
                ? 0
                : this.tablePage * this.tablePageSize + 1;
        },
        paginationEnd() {
            return Math.min(
                (this.tablePage + 1) * this.tablePageSize,
                this.filteredOpenActionDocuments.length
            );
        },
        currentPage() {
            return this.tablePage + 1;
        },
        currentChunk() {
            return Math.ceil(this.currentPage / 5);
        },
        totalChunks() {
            return Math.ceil(this.totalPages / 5);
        },
        chunkStart() {
            return (this.currentChunk - 1) * 5 + 1;
        },
        chunkPageNumbers() {
            const count = this.chunkStart + 5 <= this.totalPages
                ? 5
                : this.totalPages - this.chunkStart + 1;
            return Array.from({ length: count }, (_, i) => this.chunkStart + i);
        },
        paginationCount() {
            const total = this.filteredOpenActionDocuments.length;
            if (total === 0) return '';
            if (total === 1) return '1 resultaat';
            if (this.totalPages === 1) return `${total} resultaten`;
            return `${this.paginationStart} tot ${this.paginationEnd} van de ${total} resultaten`;
        },
    },

    methods: {

        /**
         * Retrieve the id from a collection of checks.
         * The check used will be based on the type of check.
         * @param checks
         */
        getCheckId(checks) {
            const unfinishedChecks = checks.filter((check) => !check.agreed)

            // If there is not just one unfinished check, return null,
            // we can't find the proper check for sure
            if (unfinishedChecks.length !== 1) {
                return null
            }

            return unfinishedChecks[0].id
        },
        // ID-364: Single source-of-truth filter — always recomputes from full openActionDocuments
        // so all active filters are applied together and search covers all records.
        applyAllFilters() {
            this.tablePage = 0;
            let docs = Object.values(this.openActionDocuments).filter(d => d.action_progress);

            if (this.filters.trajectory) {
                const needle = this.filters.trajectory.toLowerCase();
                docs = docs.filter(d =>
                    (d.action_progress.milestone_progress.trajectory_enrolment.trajectory.name || '')
                        .toLowerCase().includes(needle)
                );
            }

            if (this.filters.trajectory_manager) {
                const needle = this.filters.trajectory_manager.toLowerCase();
                docs = docs.filter(d =>
                    (d.action_progress.milestone_progress.trajectory_enrolment.trajectory_manager?.full_name || '')
                        .toLowerCase().includes(needle)
                );
            }

            if (this.filters.report) {
                const needle = this.filters.report.toLowerCase();
                docs = docs.filter(d =>
                    (d.action_progress.action.name || '').toLowerCase().includes(needle)
                );
            }

            if (this.inspectorOnly) {
                docs = docs.filter(d =>
                    (d.checks || []).some(ch => !ch.agreed && ch.type === 'trajectory_inspector')
                );
            }

            this.filteredOpenActionDocuments = docs;
        },
        goPrevChunk() {
            if (this.currentChunk > 1) {
                this.tablePage = (this.currentChunk - 2) * 5;
            }
        },
        goNextChunk() {
            if (this.currentChunk < this.totalChunks) {
                this.tablePage = this.currentChunk * 5;
            }
        },
        relationLink(openActionDocument) {
            return {
                name: 'admin.relations.view',
                params: {'id': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.relation.id}
            }
        },
        trajectoryLink(openActionDocument) {
            return {
                name: 'admin.relations.trajectory-enrolments.view',
                params: {
                    'relationId': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.relation.id,
                    'trajectoryEnrolmentId': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.id,
                }
            }
        },
        trajectoryManagerLink(openActionDocument) {
            return {
                name: 'admin.relations.view',
                params: {
                    'id': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.trajectory_manager.id,
                }
            }
        },
        actionDocumentLink(openActionDocument) {
            return {
                name: 'admin.relations.trajectory-enrolments.milestone-progresses.action-progresses.action-document.check',
                params: {
                    'relationId': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.relation_id,
                    'trajectoryEnrolmentId': openActionDocument.action_progress.milestone_progress.trajectory_enrolment.id,
                    'milestoneProgressId': openActionDocument.action_progress.milestone_progress.id,
                    'actionProgressId': openActionDocument.action_progress.id,
                    'checkId': this.getCheckId(openActionDocument.checks),
                }
            }
        },

        sortData() {
            const getByPath = (obj, path) =>
                path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj);

            const getSubmittedAt = (doc) => {
                const c = (doc.checks || []).find(ch => !ch.agreed && ch.checker);
                return c ? c.created_at : null;
            };

            this.filteredOpenActionDocuments = [...this.filteredOpenActionDocuments].sort((a, b) => {
                const valueA = this.sortColumn === 'submitted_at'
                    ? getSubmittedAt(a)
                    : getByPath(a, this.sortColumn);

                const valueB = this.sortColumn === 'submitted_at'
                    ? getSubmittedAt(b)
                    : getByPath(b, this.sortColumn);

                if (typeof valueA === 'string' && typeof valueB === 'string') {
                    return this.sortOrder === 'asc'
                        ? valueA.localeCompare(valueB)
                        : valueB.localeCompare(valueA);
                }

                if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
                if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
                return 0;
            });
        },
        sortTable(column) {
            this.tablePage = 0;
            if (this.sortColumn === column) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortColumn = column;
                this.sortOrder = 'asc';
            }
        },
    }
    }
</script>
<style lang="scss">
    .checker:not(:last-child) {
        padding-right: 20px;
    }
    table.action-documents-table {
        tr:first-child {
            td, th {
                text-align: left;
                border-top: none;
            }
        }
        td, th {
            padding-left: 0px !important;
        }

    }
    .action_icon {
        color: #5A4587 !important;
    }

    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }

    .override-th-min-width {
        min-width: 10px;
    }

    .w10 {
        width: 10%
    }

    .w30 {
        width: 30%
    }

</style>
<style lang="scss" scoped>
    .rowsPerPageClass {
        display: inline-block;
        width: 80px;
        padding: 4px 6px;
    }

    table.action-documents-table {
        tr:first-child {
            th.icon-sort-header {
                padding-right: 14px;
                cursor: pointer;
            }
            td, th {
                text-align: left;
                border-top: none;
            }
            td:nth-child(6), th:nth-child(6) {
                text-align: center;
            }
        }
        td, th {
            padding-left: 0px !important;
        }
        td:nth-child(6), th:nth-child(6) {
            text-align: center;
        }
    }
    .action_icon {
        color: #5A4587 !important;
    }

    .action_icon:hover {
        color: lighten(#5A4587, 25%) !important;
    }

    .card-block {
        position: relative;
        min-height: 75px;
    }

    .override-th-min-width {
        min-width: 10px;
    }

    .table-heading {
        width: 100%;
    }

    .w10 {
        width: 10%
    }

    .w30 {
        width: 30%
    }

    .header-content {
        display: inline-flex;
        align-items: center;
        gap: 4px;
    }

    .icon-sort {
        position: relative;
        margin-left: 3px;
        display: inline-block;
        width: 10px;
        height: 10px;
    }

    .icon-sort::before, .icon-sort::after {
    content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0; 
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
    }

    .icon-sort::before {
        top: 0%;
        border-bottom: 5px solid #808080;
    }

    .icon-sort::after {
        top: 60%;
        border-top: 5px solid #808080;
    }

    .icon-sort.-ascending::before {
        border-bottom: 5px solid #c1006d;
    }

    .icon-sort.-descending::after {
        border-top: 5px solid #c1006d;
    }

</style>
